module.exports = __webpack_public_path__ + "assets/img/solar-collectors.c400f64a.webp";